import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import columbario04 from "../assets/images/columbario04.jpg";
import ambiente01 from "../assets/images/ambiente01.jpg";
import cemiterio01 from "../assets/images/cemiterio01.jpg";
import jardim01 from "../assets/images/jardim03.jpg";
import estrutura01 from "../assets/images/estrutura01.jpg";
import logoImg from "../assets/images/logo.jpg";
import { useState } from 'react';

const AboutContainer = styled.div`
  color: #fff;
  background: #1A365D;
  padding: 100px 0;

  @media screen and (max-width: 768px) {
    padding: 70px 0;
  }
`;

const AboutWrapper = styled.div`
  display: grid;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  grid-template-columns: 1fr 1fr;
  grid-gap: 50px;
  justify-content: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AboutContent = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

const TopLine = styled(motion.p)`
  color: #4CAF50;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-family: 'Open Sans', sans-serif;
`;

const Heading = styled(motion.h2)`
  margin-bottom: 24px;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;
  font-family: 'Playfair Display', serif;

  @media screen and (max-width: 480px) {
    font-size: 26px;
  }
`;

const Subtitle = styled(motion.p)`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
`;

const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Button = styled(motion.button)`
  border-radius: 4px;
  background: #4CAF50;
  white-space: nowrap;
  padding: 12px 30px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #4CAF50;
  }
`;

const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

const ImgGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 16px;
  max-width: 555px;
  margin-top: 40px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
    margin-top: -30px;
  }
`;

const Img = styled(motion.img)`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
`;

const Stats = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const StatItem = styled(motion.div)`
  text-align: center;
`;

const StatNumber = styled.h3`
  font-size: 36px;
  color: #4CAF50;
  margin-bottom: 5px;
  font-family: 'Playfair Display', serif;
`;

const StatText = styled.p`
  font-size: 14px;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
`;

const StoryLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StoryLogo = styled.div`
  width: 150px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5);
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    margin-top: -15px;
`;

const StoryLogoImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #fff;
  /*object-fit: cover;*/
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: #111;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 28px;
  position: absolute;
  top: 24px;
  right: 32px;
  cursor: pointer;
  z-index: 10000;
`;

const About = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <AboutContainer id="about">
      <AboutWrapper>
        <AboutContent>
          <StoryLogoWrapper>
            <StoryLogo onClick={() => setShowModal(true)}>
              <StoryLogoImg src={logoImg} alt="Logo" />
            </StoryLogo>
            <Heading
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Memorial Crematório e Cemitério Dom José
            </Heading>
          </StoryLogoWrapper>
          {/*<TopLine
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Sobre
          </TopLine>*/}
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            style={{ marginTop: '15px' }}
          >
            Espaço concebido para oferecer acolhimento, dignidade e tranquilidade nos momentos mais delicados da vida. Com uma estrutura moderna e completa, une conforto, respeito e inovação em cada detalhe.
          </Subtitle>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Fundado em 2011, tornou-se referência no Estado pelo cuidado com as famílias e pela excelência nos serviços de velório, sepultamento e cremação. Localizado em Santa Rosa/RS, em uma área de 50 mil m², o Memorial conta com ambientes planejados para proporcionar serenidade e bem-estar.
          </Subtitle>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Sendo o único cemitério ecológico da região, tendo as opções de jardim, gavetas e convencional.
          </Subtitle>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            No Memorial Dom José, cada detalhe é pensado para tornar a despedida mais humana, respeitosa e acolhedora.
          </Subtitle>
          <Stats>
            <StatItem
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <StatNumber>2011</StatNumber>
              <StatText>Ano de Fundação</StatText>
            </StatItem>
            <StatItem
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              <StatNumber>50mil</StatNumber>
              <StatText>m² de Área</StatText>
            </StatItem>
            <StatItem
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <StatNumber>5+</StatNumber>
              <StatText>Opções de Cemitérios</StatText>
            </StatItem>
          </Stats>
          <BtnWrap>
            <Button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1 }}
              onClick={() => setShowModal(true)}
            >
              Conhecer a Estrutura
            </Button>
          </BtnWrap>
          {showModal && (
            <ModalOverlay onClick={() => setShowModal(false)}>
              <ModalContent onClick={e => e.stopPropagation()}>
                <CloseButton onClick={() => setShowModal(false)}>&times;</CloseButton>
                <video width="360" height="640" controls autoPlay style={{ borderRadius: 12 }}>
                  <source src={require('../assets/images/video-stories.mp4')} type="video/mp4" />
                  Seu navegador não suporta vídeo.
                </video>
              </ModalContent>
            </ModalOverlay>
          )}
        </AboutContent>
        <ImgWrap>
          <ImgGrid>
            <Img
              src={estrutura01}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            />
            <Img
              src={cemiterio01}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            />
            <Img
              src={columbario04}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
            />
            <Img
              src={ambiente01}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.1 }}
            />
            
          </ImgGrid>
        </ImgWrap>
      </AboutWrapper>
    </AboutContainer>
  );
};

export default About;
